import { useCallback } from 'react';
import { useDispatch, incrementViewVersion } from '../state';

export function useRefresh() {
  const dispatch = useDispatch();
  return useCallback(
    (doRefresh = true) => doRefresh && dispatch(incrementViewVersion()),
    [dispatch],
  );
}
